export default __webpack_public_path__ + "static/media/전북.83ebd8ca.svg";